// stores/screen.js
import XEUtils from 'xe-utils'//工具类
import {defineStore} from 'pinia';

export const useScreenStore = defineStore('screen', {
    state: () => ({
        screenWidth: window.innerWidth,  // 实时屏幕宽度
        isMobile: window.innerWidth < 768, // 是否移动端（根据需求调整断点）
        errmsg: false,
				URLTYPE: window.location.href.indexOf('sbipro') != -1 ? 'sbipro' : 'sbipro',//项目类型，根据获取网页判断是哪个项目
    }),
  
    actions: {
        // 更新屏幕尺寸状态
        updateScreenSize() {
            this.screenWidth = window.innerWidth;
            this.isMobile = window.innerWidth < 768;
            // console.log('监听到啦',this.screenWidth)
        },
        // 初始化监听（在应用启动时调用）
        initScreenListener() {
            this.updateScreenSize(); // 初始化状态
            // window.addEventListener('resize', this.updateScreenSize);
            window.addEventListener('resize', XEUtils.debounce(this.updateScreenSize, 100))
        },
        // 停止监听（可选，用于清理）
        stopScreenListener() {
            window.removeEventListener('resize', this.updateScreenSize);
        },
        // 更新请求弹出框状态
        updateErrmsg(msg) {
            this.errmsg = msg;
        },
    }
})
